(function($) {
$(document).on("ready", function () {
  var $offset = 0;

  if( $('section.news-posts').length ) {
      const $container = $(".js-news-wrapper"),
      $date_filter = $('#news-date-changer'),
      $loadMoreBtn = $('#load-more-news-posts'),
      $offset_amount = parseInt($container.attr('data-offset_amount'));

      $category = $container.attr('data-category');

      $(document).on('input','#news-date-changer', function(){
        $offset = 0;
        loadNewsResults(false);
      });

      $(document).on('click', '#load-more-news-posts', function(){
          loadNewsResults(true);
      });

      function check_news_pages($date, $offset){
          var sendData = {
              action: 'check_news_pages',
              date_year: $date,
              show: $offset_amount,
              offset: $offset,
              category: $category,
          };

          $.ajax({
              url: ajaxadminurl.ajaxurl,
              type: 'GET',
              data: sendData,
              dataType: 'html',
              cache: false,
              timeout: 10000,
              success: function(data, textStatus, jqXHR) {
                  $loadMoreBtn.fadeOut();
                  
                  if(parseInt(data) > (($offset + 3) / 3) && parseInt(data) > 1){
                      $loadMoreBtn.fadeIn();
                  }
              }
          });
      }

      function loadNewsResults($load_more) {
          $date = $date_filter.val();

          if($load_more == true){
              $offset += $offset_amount;
          }

          check_news_pages($date, $offset);

          var sendData = {
              action: 'news_ajax_handler',
              date_year: $date,
              show: $offset_amount,
              offset: $offset,
              category: $category,
          };

          $.ajax({
              url: ajaxadminurl.ajaxurl,
              type: 'GET',
              data: sendData,
              dataType: 'html',
              cache: false,
              timeout: 10000,
              success: function(data, textStatus, jqXHR) {
                  var htmlData = $.parseHTML(jqXHR.responseText);
                  if($load_more == true){
                      $container.append(htmlData);
                  } else {
                      $container.html(htmlData);
                  }
              },
              complete: function(data) {
                  if (data.responseText !== '<div class="nothing-found"><h4>No results found</h4></div>') {
                  } else {
                      $loadMoreBtn.fadeOut();
                  }
                  AOS.init();
              }
          });
      }
      loadNewsResults(false);
  }
});


})( jQuery );